import React, {Component} from 'react';
import {
    Menu,
    Icon,
    Image,
    Dropdown, Header,
} from 'semantic-ui-react'
import {Route, Switch, Link, withRouter, Redirect} from 'react-router-dom';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import moment from 'moment';

import ContactsRoute from '../routes/ContactsRoute';
import InventoriesRoute from '../routes/InventoriesRoute';
import Expenses from '../containers/expenses/Expenses';
import HomeRoute from '../routes/HomeRoute';
import SecurityRoute from '../routes/SecurityRoute';
import SettingsRoute from '../routes/SettingsRoute';
import SalesRoute from '../routes/SalesRoute';
import SaleRoute from '../routes/SaleRoute';
import ReportsRoute from '../routes/ReportsRoute';
import Error404 from './Error404';
import AccessDenied from './AccessDenied';
import UpgradePlan from "./UpgradePlan";

import auth from '../data/auth';
import localDB from '../data/localDB';
import FindClient from "../components/contacts/FindClient";
import ClientDialog from "../components/contacts/ClientDialog";
import ProviderDialog from "../components/contacts/ProviderDialog";
import TaxDialog from "../components/settings/TaxDialog";
import ChangeLogs from "./home/ChangeLogs";
import SocketStore from "../components/sockets/SocketStore";
import ServicesRoute from "../routes/ServicesRoute";
import DeliveryRoute from "../routes/DeliveryRoute";
import RepairRoute from "../routes/RepairRoute";

const text = require('../img/logo_text1.svg');
const logo_makaw_dev = require('../img/logo_makaw_dev.svg');
const now = moment();
now.locale('es').utcOffset(0);

class DashboardLayout extends Component {
    constructor() {
        super();
        this.state = {
            items_menu: [],
            visible: false,
            cards: [],
            suscription_text: '',
            diff_days: 360,
            toggle: false
        };
    }

    componentDidMount() {
        this.itemsMenu();
        let suscription_date = moment(localDB.get('store').suscription_date);
        let diff_days = suscription_date.diff(now, 'days');
        if(diff_days<=0){
            this.setState({suscription_text:' Tu suscripción ha caducado!'});
        }else if(diff_days<=8){
            this.setState({suscription_text:` Tu suscripción caducará en ${diff_days}!`});
        }
        this.setState({diff_days});
    }

    handleLogout() {
        auth.logout(() => {
            this.props.history.push('/');
        });
    };

    itemsMenu = () =>{
        let menu = localDB.get('menu');
        let cards = menu.filter(menu => menu.type === 'main').map(item => {
            let submenu = menu.filter(sub_menu => sub_menu.parent===item.url);
            return (
                    <NavItem eventKey={item.url} key={item.url}>
                        <NavIcon>
                            <Image src={item.icon} height={30} alt='logo' className='icon-side-nav'/>
                        </NavIcon>
                        <NavText>
                            {item.name}
                        </NavText>
                        {submenu.map(sub_menu => {
                            return(
                                <NavItem eventKey={sub_menu.url} key={sub_menu.url}>
                                    <NavText>
                                        {sub_menu.name}
                                    </NavText>
                                </NavItem>
                            )
                        })}
                    </NavItem>
            )
        });
        this.setState({cards});
    };

    closeAlert = () =>{
        this.setState({diff_days:360});
    };

    render() {
        return (
            <div>
                <Menu borderless className='sidenav-menu'>
                    <Menu.Menu position='left'>
                        <Menu.Item style={{marginLeft:this.state.toggle ? 200:0}}>
                            <Link to='/'>
                                {localDB.get('store').logo_url ? <Image src={localDB.get('store').logo_url} height={36} alt='logo'/>:<Image src={text} height={36} alt='logo'/>}
                            </Link>
                        </Menu.Item>
                    </Menu.Menu>
                    <Menu.Menu position='right'>
                        <Dropdown pointing text={localDB.getUser().full_name} labeled className='link item' onClick={this.handleItemClick}>
                            <Dropdown.Menu>
                                <Dropdown.Item icon='sign out' onClick={() => this.handleLogout()} text='Cerrar Sesión'/>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Menu>
                </Menu>
                {this.state.diff_days <= 8 ? <div className='top-menu'>
                    <Icon fitted name='alarm' />{this.state.suscription_text}
                    <Link to='/settings/suscription' style={{color:'#ffffff'}}> Renovar mi suscripción</Link>
                    <span onClick={this.closeAlert}  style={{float: 'right', marginRight:10, cursor:'pointer'}}><Icon fitted name='close' /></span>
                </div>:null}
                <React.Fragment>
                    <SideNav
                    onSelect={(selected) => {
                        if (this.props.location.pathname !== selected) {
                            if(selected === '/updates'){
                                this.props.history.push(selected);
                                localDB.set('change_logs', 0);
                            }else if(selected === '/support'){
                                window.open("https://help.quipuu.com","_blank")
                            }else{
                                this.props.history.push(selected);
                            }
                        }
                    }}
                    onToggle={(toggle) => this.setState({toggle})}
                    className='nav-style'
                >
                    <SideNav.Toggle/>
                    <SideNav.Nav defaultSelected="/">
                        {this.state.cards}
                        {/* <NavItem eventKey='/support'>
                            <NavIcon>
                                <Image src={require('../img/icons/support_white.svg')} height={30} alt='logo' className='icon-side-nav'/>
                            </NavIcon>
                            <NavText>Ayuda y Soporte</NavText>
                        </NavItem> */}
                        {/* <NavItem eventKey='/updates'>
                            <NavIcon>
                                <Image src={require('../img/icons/rocket_white.svg')} height={30} alt='logo' className='icon-side-nav'/>
                                {localDB.get('change_logs') > 0 ? <Label circular style={{backgroundColor:'white'}} className='change-logs-notification' size='mini'>{localDB.get('change_logs')}</Label>:null}
                            </NavIcon>
                            <NavText>Actualizaciones</NavText>
                        </NavItem> */}
                    </SideNav.Nav>
                </SideNav>
                    <main style={{margin: 40, marginLeft:this.state.toggle ? 270:100, minHeight:'69vh'}}>
                        <Switch>
                            <Route path='/inventories' component={InventoriesRoute}/>
                            <Route path='/contacts' component={ContactsRoute}/>
                            <Route path='/settings' component={SettingsRoute}/>
                            <Route path='/security' component={SecurityRoute}/>
                            <Route path='/sale' component={SaleRoute}/>
                            <Route path='/sales' component={SalesRoute}/>
                            <Route path='/services' component={ServicesRoute}/>
                            <Route exact path="/access-denied" component={AccessDenied}/>
                            <Route exact path="/upgrade-plan" component={UpgradePlan}/>
                            <Route exact path="/expenses" component={Expenses}/>
                            <Route exact path="/updates" component={ChangeLogs}/>
                            <Route exact path="/deliveries" component={DeliveryRoute}/>
                            <Route exact path="/repair" component={RepairRoute}/>
                            <Route path="/reports" component={ReportsRoute}/>
                            {!localDB.get('store_security').can_view_home ? <Redirect exact from="/" to="/sale" />:null}
                            <Route path='/' component={localDB.get('store_security').can_view_home ? HomeRoute:SaleRoute}/>
                            <Route exact path={'*'} component={Error404}/>
                        </Switch>
                    </main>
                    <Header as='h3' textAlign='center'>
                        <a href='https://makaw.dev' target='_blank'>
                            <img src={logo_makaw_dev} height={60} alt='logo'/>
                        </a>
                    </Header>
                </React.Fragment>
                <FindClient/>
                <ClientDialog />
                <ProviderDialog />
                <TaxDialog />
                <SocketStore />
            </div>
        );
    }
}

export default withRouter(DashboardLayout);




// WEBPACK FOOTER //
// ./src/containers/DashboardLayout.js